import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Tag
} from 'antd'
import ProductBrandPic from '../../assets/images/brands.png'
import IntlMessages from '../../util/IntlMessages'
import ds from '../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import AddBrand from '../../components/AddBrand'
import { useHistory } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { loadData } from '../../appRedux/actions/Setting'
import { userLogOut } from '../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../appRedux/actions/CommonData'
import { BRANDS } from '../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { TableName } from '../../constants/TableName'
import NotAllowedComponent from '../../components/NotAllowedComponent'

const Panel = Collapse.Panel
const confirm = Modal.confirm

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const Brands = ({ match }) => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [getBrandID, setBrandID] = React.useState(0)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [getTableData, setTableData] = React.useState([])
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [loadDataState, setloadDataState] = useState(false)
  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })

  React.useEffect(() => {
    dispatch(setCommonConfigs(BRANDS))
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    handleChange()
    const unsub = store.subscribe(handleChange)
    getBrandsListing(getPagination)

    return () => {
      unsub()
    }
  }, [loadDataState])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getBrandsListing (body) {
    //
    const getBrands = ds.getBrandsData(body, BEHAVIOUR_TYPE.GET)
    await getBrands
      .then(res => {
        //;
        if (res.data.data && res.data.data.length > 0) {
          let mapped = res.data.data.map(brands => {
            return {
              key: brands.brandID,
              name: brands.name,
              description: brands.description,
              numofproducts: brands.nbrOfProducts,
              createdon: brands.createdOn
            }
          })
          let paginationobj = {
            CurrentPageNo: res.data.data[0].currentPageNo,
            PageSize: res.data.data[0].pageSize,
            total: res.data.data[0].totalRecords,
            showSizeChanger: true
          }
          // mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1));
          setTableData(mapped)
          setPagination(paginationobj)
        }
        setIsLoading(false)
        setIsLoadingTable(false)
        setSpinningLoading(false)
        if (loadDataState) {
          setloadDataState(false)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        setIsLoadingTable(false)
      })
  }

  const columns = [
    {
      title: <IntlMessages id='products.brands.name' />,
      dataIndex: 'name',
      key: 'name',
      render: text => {
        return (
          <span className='gx-link' style={{ fontWeight: '500' }}>
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.description' />,
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: <IntlMessages id='products.brands.noofproducts' />,
      dataIndex: 'numofproducts',
      key: 'numofproducts'
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <span>
      //          {record.numofproducts}
      //         </span>
      //       </div>
      //     );
      //   },
    },
    {
      title: <IntlMessages id='products.brands.viewproduct' />,
      key: 'viewproduct',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const viewProduct = async brandID => {
          history.push(`/dashboard/products/main/listing/brandid/${brandID}`)
        }
        return (
          <div>
            <span>
              <a onClick={() => viewProduct(record.key)} className='gx-link'>
                View Product
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.edit' />,
      key: 'edit',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const editBrands = (brandID, brandName, brandDesc) => {
          setVisible(true)
          // message.success("Successfully Done Product Brand");
          setBrandID(brandID)
          form.setFieldsValue({ BrandNameEdit: brandName })
          form.setFieldsValue({ BrandDescriptionEdit: brandDesc })
        }
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() =>
                  editBrands(record.key, record.name, record.description)
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.delete' />,
      key: 'delete',
      render: (text, record) => {
        const deleteBrands = async brandID => {
          setSpinningLoading(true)
          let addUpdateDeleteBrands = {
            data: {
              msgCode: '',
              msgDescription: ''
            }
          }
          await ds
            .addUpdateDeleteBrands(
              {
                BrandID: brandID,
                IsRemove: true
              },
              BEHAVIOUR_TYPE.DELETE
            )
            .then(response => (addUpdateDeleteBrands.data = response.data))
            .catch(e => notAllowMsgCheck(e))

          if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_SUCCESS') {
            setSpinningLoading(false)
            message.success('Brand Deleted')
            setTableData(getTableData.filter(a => a.key !== brandID))
            //history.push("/Dashboard/products/Brands");
            //setTimeout(() => {
            //    window.location.href = "/Dashboard/products/Brands";
            //}, 2000);
          }

          if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_ERROR') {
            setSpinningLoading(false)
            message.error(addUpdateDeleteBrands.data.msgDescription)
          }
          setSpinningLoading(false)
        }
        function showDeleteConfirm (brandID, brandName) {
          confirm({
            title: 'Are you sure delete this Brand?',
            content: `"${brandName}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteBrands(brandID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span>
            <a
              onClick={() => showDeleteConfirm(record.key, record.name)}
              className='trash-icon-btn'
            >
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]
  const handleOk = () => {
    setConfirmLoading(true)
    //this.setState({ confirmLoading: true })
    setTimeout(() => {
      setConfirmLoading(false)
      setVisible(false)
      //this.setState({ confirmLoading: false, visible: false })
    }, 2000)
  }
  const handleCancel = () => {
    //props['IsShow'] = false;
    setVisible(false)

    //this.setState({ visible: false })
  }
  const onFinishFailed = errorInfo => {
    message.error('Kindly attend to the wrong Input')
  }
  const onFinish = async values => {
    //;
    setVisible(false)
    setSpinningLoading(true)

    let addUpdateDeleteBrands = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }

    await ds
      .addUpdateDeleteBrands(
        {
          BrandID: getBrandID,
          BrandName: values.BrandNameEdit,
          BrandDescription: values.BrandDescriptionEdit,
          IsRemove: false
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(response => (addUpdateDeleteBrands.data = response.data))
      .catch(e => {
        notAllowMsgCheck(e)
        setSpinningLoading(false)
      })

    if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_SUCCESS') {
      dispatch(loadData(true))
      //setSpinningLoading(false);
      //setTableData([]);
      //getListingTableData();
      //history.push("/Dashboard/products/Brands");
      //message.success("Successfully Updated " + values.BrandNameEdit);
      setTimeout(() => {
        //setSpinningLoading(false);
        //window.location.href = "/Dashboard/products/Brands";
      }, 2000)
    }

    if (addUpdateDeleteBrands.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      //set(false);
      message.error(addUpdateDeleteBrands.data.msgDescription)
    }
    setTimeout(() => {
      setSpinningLoading(false)
      //window.location.href = "/Dashboard/products/Brands";
    }, 2000)
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.Brands,
      SearchValue: value,
      ID: getBrandID
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Brand name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }
  const EditModal = () => {
    return (
      <div>
        <Modal
          title={<IntlMessages id='products.brands.newbrand' />}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          centered={true}
          width={'402px'}
          footer={
            <>
              <Button form='brandsEdit' className='dk-btn-add' type='primary' htmlType='submit'>
                <IntlMessages id='products.brands.editbrand' />
              </Button>
            </>
          }
        >
          <Form
            {...formItemLayout}
            form={form}
            name='brandsEdit'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86'
            }}
            scrollToFirstError
          >
            <Form.Item
              className='form-inner-pad-0'
              name='BrandNameEdit'
              label={
                <span>
                  <IntlMessages id='products.brands.brandname' />
                  <Tooltip title='Brand Name'></Tooltip>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter Brand name',
                  whitespace: true
                },
                {
                  validator: valideDuplicateName
                }
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              className='form-inner-pad-0'
              name='BrandDescriptionEdit'
              label={
                <span>
                  <IntlMessages id='products.brands.description' />
                  <Tooltip title='Brand Description'></Tooltip>
                </span>
              }
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }

  const handleChange = () => {
    if (store.getState().settings.loadData != loadDataState) {
      setloadDataState(store.getState().settings.loadData)
      dispatch(loadData(false))
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setIsLoadingTable(true)
    var body = getPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getBrandsListing(body)
  }

  // async function postSaveExcelCall (body) {
  //   setIsLoading(true)
  //   setIsLoadingTable(true)
  //   setSpinningLoading(true)
  //   const req = ds.postSaveExcelService(body)
  //   await req
  //     .then(response => {
  //       setIsLoading(false)
  //       setIsLoadingTable(false)
  //       setSpinningLoading(false)
  //       if (response) {
  //         const aaa = 1
  //       }
  //     })
  //     .catch(e => {
  //       setIsLoading(false)
  //       setIsLoadingTable(false)
  //       setSpinningLoading(false) // message.error("Something Went Wrong...");
  //     })
  // }

  // async function postExport_B_64_Call (body) {
  //   setIsLoading(true)
  //   setIsLoadingTable(true)
  //   setSpinningLoading(true)
  //   const req = ds.postExport_B_Service(body)
  //   await req
  //     .then(response => {
  //       setIsLoading(false)
  //       setIsLoadingTable(false)
  //       setSpinningLoading(false)
  //       if (response) {
  //         const aaa = 1
  //       }
  //     })
  //     .catch(e => {
  //       setIsLoading(false)
  //       setIsLoadingTable(false)
  //       setSpinningLoading(false) // message.error("Something Went Wrong...");
  //     })
  // }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='products.addeditpriceprod.savebook' />}
      spinning={isSpinningLoading}
      size='large'
    >
      <div className='Content-wrapper Brands-pg'>

      <Row className="align-items-center justify-content-center mb-3 Product-header">
      <Col lg={12} md={12} sm={24} xs={24}>
          <h1 className="mb-0">
              <IntlMessages id="products.brands.brands" />
            </h1>
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <div className="pg-header-btn">
              {!getIsDisableCreate && (
                <AddBrand />
              )}
            </div>
          </Col>
        </Row>

        <Card className='gx-card' title=''>
          <Collapse>
            <Panel
              className='custom-promolist-help'
              showArrow={false}
              header={<IntlMessages id='products.brands.needhelpheading' />}
            >
              <Row>
                <div className='billing-main'>
                  <Col className='custom-promolist-helpdesc' md={12}>
                    <p>
                      <IntlMessages id='products.brands.needhelpdescription1' />
                    </p>
                    <p>
                      <IntlMessages id='products.brands.needhelpdescription2' />
                    </p>
                  </Col>

                  <Col md={12}>
                    <img src={ProductBrandPic} alt='' />
                  </Col>
                </div>
              </Row>
            </Panel>
          </Collapse>
        </Card>

        <div className='tab-body-parent'>
          <Card>
            {isLoading ? (
              <Skeleton count={7} height={35} />
            ) : (
              <Table
                className='gx-table-responsive'
                loading={isLoadingTable}
                columns={columns}
                dataSource={getTableData}
                pagination={getPagination}
                onChange={handleTableChange}
                // rowKey={(record) => record.key}
              />
            )}
            <EditModal />
          </Card>
        </div>
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default Brands
